// React
import React, { useEffect, useState, useRef } from "react";

const WatermarkedImage = ({
  src,
  width = 200,
  height = 200,
  alt = "",
  marker = "FOR INTERNAL USE",
}) => {
  const canvasRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!src || !canvasRef.current || hasError) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // ล้าง Canvas ก่อนวาดใหม่
    ctx.clearRect(0, 0, width, height);

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = src;

    img.onload = () => {
      // 1. วาดรูปต้นฉบับ
      ctx.drawImage(img, 0, 0, width, height);

      // 2. ตั้งค่าลายน้ำ
      ctx.font = `bold ${Math.max(width / 15, 12)}px Arial`;
      ctx.fillStyle = "rgba(255, 0, 0, 0.3)";
      ctx.textAlign = "center";

      // 3. วาดลายน้ำแนวทแยง
      const step = Math.max(width, height) / 2;
      for (let i = -height; i < width * 2; i += step) {
        ctx.save();
        ctx.translate(i, i);
        ctx.rotate((-45 * Math.PI) / 180);
        ctx.fillText(marker, 0, 0);
        ctx.restore();
      }
    };

    img.onerror = () => {
      setHasError(true);
      // วาดพื้นหลังเมื่อโหลดรูปไม่สำเร็จ
      ctx.fillStyle = "#f0f0f0";
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = "red";
      ctx.textAlign = "center";
      ctx.fillText("Image Failed to Load", width / 2, height / 2);
    };
  }, [src, width, height, hasError]);

  // แสดงผลลัพธ์
  return (
    <div style={{ position: "relative", width, height }}>
      {hasError ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "red",
            border: "1px dashed #ccc",
          }}
        >
          Failed to Load Image
        </div>
      ) : (
        <canvas
          ref={canvasRef}
          width={width}
          height={height}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
          aria-label={alt}
        />
      )}
    </div>
  );
};

export default WatermarkedImage;
